import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import {Hub} from '../types/hub';
import {HubService} from '../services/hub.service';
import {AppComponent} from '../app.component';
import {Installation} from '../types/installation';

@Component({
  selector: 'installation-category',
  template: `<ul class="installs">
  <li class="h3">{{category}} ({{count}})<br>
    <one-install [header]="true" (sortColumn)="onSortColumn($event)"></one-install>
  </li>
  <ng-container *ngIf="expanded">
    <li *ngFor="let install of installations"
        [class.selected]="install === current"
        (click)="gotoDetail(install)">
      <one-install *ngIf="install.status === category" [row]="install"></one-install>
    </li>
  </ng-container>
</ul>
`,
  styles: [
    `.selected { background-color: #CFD8DC !important; color: white; }`,
    `.installs { margin: 0 0 2em 0; list-style-type: none; padding: 0; min-width: 32em; width: 100%; }`,
    `.installs li { display: block; background-color: #EEE; margin: 0.2em 0; vertical-align: middle; }`,
    `.installs li:hover { color: #304D6B; background-color: #DDD; }`,
  ],
  providers: [HubService],
})
//  [style.background-color]="this.getColorFor(hub)"


export class InstallationCategoryComponent implements OnInit {
  @Input() category: string;
  @Input() installations: Installation[];
  @Input() expanded: boolean;
  @Input() count: number;
  current: Installation;
  errorMessage: any;
  sortColumn: string;
  sortAscending: boolean;
  sortNumeric: boolean;

  constructor(
  ) {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
  }

  onSortColumn(e: string) {
    let columnSort = e.split(':');
    this.sortBy(columnSort[0], columnSort[1] === 'true');
  }

  sortBy(column: string, numeric: boolean): void {
    if (this.sortColumn && this.sortColumn === column) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortColumn = column;
      this.sortNumeric = numeric;
      this.sortAscending = true;
    }
    this.sortRows();
  }

  private sortRows(): void {
    let sortColumn = this.sortColumn;
    let sortNumeric = this.sortNumeric;
    let sortAscending = this.sortAscending;
    this.installations.sort(function(a, b) {
      let result = 0;
      try {
        let f1 = a[sortColumn];
        let f2 = b[sortColumn];
        if (sortNumeric) {
          result = f1 - f2;
        } else {
          result = (f1 < f2 ? -1 : (f1 > f2 ? 1 : 0));
        }
        if (!sortAscending) {
          result *= -1;
        }
      } catch (e) {
        console.log(e.message);
        console.log(`sortColumn: ${sortColumn}`);
        console.log(`a: ${JSON.stringify(a, null, 2)}`);
      }
      return result;
    });
  }

  gotoDetail(install: Installation): void {
    // this.router.navigate(['/stock/install', install.job_id]);
    console.log(JSON.stringify(install, null, 2));
    console.log('Status: ' + install.status);
  }

}

